"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var antd_1 = require("antd");
var formik_1 = require("formik");
var react_1 = __importStar(require("react"));
var contexts_1 = require("../../contexts");
var hooks_1 = require("../../hooks");
var FormatText_1 = __importDefault(require("../FormatText"));
var FormItem_1 = __importDefault(require("../FormItem"));
var Option = antd_1.Select.Option;
var FormSelect = function (props) {
    var name = props.name, placeholder = props.placeholder, label = props.label, span = props.span, validate = props.validate, validateSchema = props.validateSchema, options = props.options, getOptions = props.getOptions, valueExtractor = props.valueExtractor, textExtractor = props.textExtractor, required = props.required, onChange = props.onChange, selectProps = __rest(props, ["name", "placeholder", "label", "span", "validate", "validateSchema", "options", "getOptions", "valueExtractor", "textExtractor", "required", "onChange"]);
    var loadOptions = getOptions || Promise.resolve(options || []);
    var optionsData = hooks_1.usePromise(loadOptions, [getOptions, options], [])[0];
    var mountOption = react_1.useMemo(function () {
        var transformedOptions = optionsData.map(function (option) {
            var value = valueExtractor ? valueExtractor(option) : option.value;
            var text = textExtractor ? textExtractor(option) : option.text;
            return (react_1.default.createElement(Option, { key: "select-option-" + value, value: value },
                react_1.default.createElement(FormatText_1.default, { id: text })));
        });
        var emptyOption = (react_1.default.createElement(Option, { key: "select-option-empty", className: "ant-app-select-option-empty", disabled: true }, typeof placeholder === 'string' ? (react_1.default.createElement(FormatText_1.default, { id: placeholder })) : (react_1.default.createElement(FormatText_1.default, { id: "ui.commons.select.empty" }))));
        return required ? transformedOptions : [emptyOption].concat(transformedOptions);
    }, [optionsData, valueExtractor, textExtractor, required, placeholder]);
    return (react_1.default.createElement(FormItem_1.default, __assign({}, { name: name, label: label, span: span, validate: validate, validateSchema: validateSchema, required: required }),
        react_1.default.createElement(contexts_1.PermissionContext.Consumer, null, function (_a) {
            var allowEdit = _a.allowEdit;
            return (react_1.default.createElement(formik_1.Field, { name: name }, function (_a) {
                var value = _a.field.value, _b = _a.form, setFieldValue = _b.setFieldValue, setFieldTouched = _b.setFieldTouched;
                return (react_1.default.createElement(antd_1.Select, __assign({ placeholder: typeof placeholder === 'string' ? react_1.default.createElement(FormatText_1.default, { id: placeholder }) : placeholder, onChange: function (val, el) {
                        setFieldValue(name, val);
                        if (onChange)
                            onChange(val, el);
                    }, onBlur: function () { return setFieldTouched(name); }, value: value, disabled: !allowEdit }, selectProps), mountOption));
            }));
        })));
};
exports.default = FormSelect;
